// One brand colour per domain (brand package "Fresh": one colour per facet). The map's domain
// corners sit where the mark's facets do: Strategic top-left (Sun), Relating top-right (Coral),
// Executing bottom-left (Leaf), Influencing bottom-right (Teal). `fill` is the bright colour for
// bars, arcs and dots; `text` is its text-safe shade (the 700 on light, the bright on dark).

import type { DomainCode } from "./types";

export const DOMAIN_COLOR: Record<DomainCode, { fill: string; text: string }> = {
  STR: { fill: "var(--color-sun)", text: "var(--color-sun-text)" },
  REL: { fill: "var(--color-coral)", text: "var(--color-coral-text)" },
  EXE: { fill: "var(--color-leaf)", text: "var(--color-leaf-text)" },
  INF: { fill: "var(--color-teal)", text: "var(--color-teal-text)" },
};

/** A domain's colours, or the accent for a code we don't know. */
export const domainColor = (code: string) => DOMAIN_COLOR[code as DomainCode] ?? { fill: "var(--color-accent)", text: "var(--color-accent-text)" };
